import LocationsTable from "./LocationsTable";
import GatewaysTable from "./GatewaysTable";
import Section from "../Section";
import {Stack} from "@mui/material";
import {defineMessage} from "react-intl";
import {useDomainIDParam} from "@/types";

const DomainStatus = ({domainId}: {domainId: number}) => {
    return (
        <Stack spacing={4}>
            <Section label={defineMessage({id: "locations", defaultMessage: "Locations"})}>
                <LocationsTable domainId={domainId} />
            </Section>
            <Section label={defineMessage({id: "gateways", defaultMessage: "Gateways"})}>
                <GatewaysTable domainId={domainId} />
            </Section>
        </Stack>
    );
};

export const DomainStatusPage = () => {
    const domainId = useDomainIDParam();

    return <DomainStatus domainId={domainId} />;
};

export default DomainStatus;
